export default {
    HEADER: 'Promocija',
    PLACEHOLDER_NAME: 'Unesite naziv promocije',
    LABEL_NAME: 'Naziv promocije',
    LABEL_PAGE: 'Stranica',
    LABEL_IMPORTANCE: 'Značaj',
    LABEL_TYPE: 'Tip',
    LABEL_PRICE: 'Cena',
    PLACEHOLDER_PRICE: 'Unesite cenu',
    PLACEHOLDER_DISCOUNTED_PRICE: 'Unesite sniženu cenu',
    LABEL_LIFECYCLE_STATUS: 'Status',
    LABEL_DISCOUNTED_PRICE: 'Snižena cena',
    LABEL_PLACE: 'Lokal',
    LABEL_START_DATE: 'Početak promocije',
    LABEL_END_DATE: 'Završetak promocije',
    LABEL_PRODUCT: 'Proizvod',
    SAVE_BUTTON: 'Sačuvaj',
    CANCEL_BUTTON: 'Poništi',
    DISCOUNTED_PRICE_INFO:
        'Polje snižena cena je isključeno dok ne unesete cenu. Molimo vas ostavite prazno polje ukoliko cena nema sniženje. Za iznos snižene cene unesite vrednost veću od 0, a manju od vrednosti cene!',
};
